import { createSelector } from 'reselect';
import createReducer from 'granite-admin/utils/ducks/create-reducer';

// ActionsNames - <NOUN>/<VERB>_<NOUN>
const UPDATE_WORKSPACE_TABS = 'accounts/workspace/UPDATE_WORKSPACE_TABS';
const SELECT_WORKSPACE = 'accounts/workspace/SELECT_WORKSPACE';
const RESET_WORKSPACE = 'accounts/workspace/RESET_WORKSPACE';

// Action creator name: <VERB><NOUN>
// Export actions
export function updateWorkspaceTabs(data) {
  return {
    type: UPDATE_WORKSPACE_TABS,
    data: data
  };
}
export function selectWorkspace(data) {
  return {
    type: SELECT_WORKSPACE,
    data: data
  };
}
export function resetWorkspace(data) {
  return {
    type: RESET_WORKSPACE,
    data: data
  };
}

// state name - <NOUN>
const defaultState = {
  tabs: [{
    id: 1,
    index: 0,
    url: '/dashboard',
    tabTitle: 'Dashboard'
  }],
  selected: 1
};

// Reducers - <NOUN>_<VERB>_REDUCER
function UPDATE_WORKSPACE_TABS_REDUCER(state, action) {
  return Object.assign({}, state, {
    tabs: action.data
  });
}
function SELECT_WORKSPACE_REDUCER(state, action) {
  return Object.assign({}, state, {
    selected: action.data
  });
}
function RESET_WORKSPACE_REDUCER(state, action) {
  return defaultState;
}
const handlers = {
  [UPDATE_WORKSPACE_TABS]: UPDATE_WORKSPACE_TABS_REDUCER,
  [SELECT_WORKSPACE]: SELECT_WORKSPACE_REDUCER,
  [RESET_WORKSPACE]: RESET_WORKSPACE_REDUCER
};

// Selectors
const workspaceSelector = state => state.accounts.workspace;
export const tabs = createSelector(workspaceSelector, workspace => workspace.tabs);
export const selected = createSelector(workspaceSelector, workspace => workspace.selected);

// export reducers as default
export default createReducer(defaultState, handlers);